import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { InputText, Text } from "@pentabd/ui";

interface InputTextVerticalType {
  register: any;
  label: string;
  name?: string;
  placeholder?: string;
  disabled?: boolean;
  error?: any;
  required?: boolean;
  restriction?: boolean;
  cols?: 2 | 3 | 4 | 6;
  type?: string;
  setValue?: any;
  inputSize?: "xs" | "sm" | "md" | "lg";
}

export const InputTextVertical = ({
  register,
  label,
  placeholder,
  disabled,
  error,
  required,
  restriction,
  cols,
  type,
  setValue,
  name,
  inputSize = "md",
}: InputTextVerticalType) => {
  const { t } = useTranslation();

  return (
    <div
      className={classNames("col-12", {
        "col-xl-4 col-2xl-2": cols === 2,
        "col-xl-4 col-2xl-3": cols === 3,
        "col-xl-4": cols === 4,
        "col-sm-6": cols === 6,
      })}
    >
      <Text
        weight="semibold"
        color="title"
        size="sm"
        component="p"
        className="mb-3"
      >
        {t(`${label}.LABEL`)}
        {required && <span className="text-danger">&#42;</span>}
      </Text>
      <>
        <InputText
          {...register}
          placeholder={t(placeholder ? placeholder : `${label}.PLACEHOLDER`)}
          error={error}
          disabled={disabled}
          type={type}
          onChange={(e) => setValue(name, e.target.value.toUpperCase())}
          controlling={setValue ? true : false}
          className={`${type === "color" && "type-color-padding"}`}
          size={inputSize}
        />
        {restriction && (
          <Text color="warning" size="xs">
            {t(`${label}.RESTRICTION`)}
          </Text>
        )}
      </>
    </div>
  );
};
